import React from 'react';
import classNames from 'classnames';
import Icon from '../icons/Icon';
import { ICONS, SIZES } from '../../constants/icons';
import defaultTheme from '../../themes/default';
import useBreakPoints from '../../hooks/useBreakPoint';

const Select = ({ id, children, className, ...otherProps }) => {
  const { is2xl } = useBreakPoints();

  return (
    <div className="relative">
      <select
        id={id}
        className={classNames(
          defaultTheme.input.base,
          defaultTheme.input.fill.primary,
          defaultTheme.select.base,
          className,
        )}
        {...otherProps}
      >
        {children}
      </select>
      <Icon
        icon={ICONS.CARET_DOWN}
        size={is2xl ? SIZES.S : SIZES.XS}
        className="pointer-events-none absolute top-1/2 transform -translate-y-1/2 right-4 2xl:right-6"
      />
    </div>
  );
};

export default Select;
